<div class="cluster-elbow-silhouette-container">
	<div [id]="ph_id" class="cluster-elbow-silhouette-ph"></div>
</div>
